import { createStyles, rem, Text } from "@mantine/core";
import * as React from "react";

import { CardsCarousel } from "./components/CardsCarousel";
import { AboutContent } from "../cala-2026/AboutContent";

const MOBILE_BREAKPOINT = "md";
const SIDEBAR_WIDTH = rem(280);
const CONTENT_TOP = rem(48);
const MOBILE_GUTTER = rem(20);
const INSTAGRAM_URL = "https://instagram.com/vidgiri";

type PageView = "work" | "about" | "publications";

interface Project {
  id: string;
  title: string;
  info: string;
  description: string;
  images: { image: string }[];
}

const printed: Project[] = [
  {
    id: "the-wave-jar",
    title: "the wave jar",
    info: "2026",
    description:
      "a comic about two sisters and the magic of the waves and enjoying the present.",
    images: [
      { image: "/releases/019.png" },
      { image: "/img/the-wave-jar-1.jpeg" },
      { image: "/img/the-wave-jar-2.jpeg" },
      { image: "/img/the-wave-jar-3.jpeg" },
      { image: "/img/the-wave-jar-4.jpeg" },
    ],
  },
  {
    id: "goldfish",
    title: "goldfish",
    info: "2026",
    description: "a short comic about goldfish.",
    images: [
      { image: "/releases/021.png" },
      { image: "/img/goldfish-1.jpeg" },
      { image: "/img/goldfish-2.jpeg" },
      { image: "/img/goldfish-3.jpeg" },
      { image: "/img/goldfish-4.jpeg" },
    ],
  },
  {
    id: "leaf",
    title: "leaf",
    info: "2026",
    description: "a short zine about leaf.",
    images: [
      { image: "/releases/020.png" },
      { image: "/img/leaf-1.jpeg" },
      { image: "/img/leaf-2.jpeg" },
      { image: "/img/leaf-3.jpeg" },
      { image: "/img/leaf-4.jpeg" },
    ],
  },
  {
    id: "mushroom-palettes",
    title: "mushroom palettes",
    info: "2026",
    description: "mushrooms i've seen and photographed",
    images: [
      { image: "/releases/018.png" },
      { image: "/img/mushroom-palettes-1.jpeg" },
      { image: "/img/mushroom-palettes-2.jpeg" },
      { image: "/img/mushroom-palettes-3.jpeg" },
      { image: "/img/mushroom-palettes-4.jpeg" },
      { image: "/img/mushroom-palettes-5.jpeg" },
      { image: "/img/mushroom-palettes-6.jpeg" },
    ],
  },
  {
    id: "tallgrass-reflections",
    title: "tallgrass reflections",
    info: "2026",
    description:
      "reflections, sketches, and field notes from my time at the tallgrass prairie artist residency.",
    images: [
      { image: "/releases/017.png" },
      { image: "/img/tallgrass-reflections-1.jpeg" },
      { image: "/img/tallgrass-reflections-2.jpeg" },
      { image: "/img/tallgrass-reflections-3.jpeg" },
      { image: "/img/tallgrass-reflections-4.jpeg" },
      { image: "/img/tallgrass-reflections-5.jpeg" },
    ],
  },
  {
    id: "hypersaline-waters",
    title: "twelve palettes of hypersaline waters",
    info: "2025",
    description:
      "a poetic sequence/color study drawn from aerial views of hypersaline ponds around the world, explaining the formation of the colors and forms, paired with their corresponding extracted hex codes. based on my piece that was published in the are.na annual 2026 book, pools!",
    images: [
      { image: "/img/hypersaline-1.jpeg" },
      { image: "/img/hypersaline-3.jpeg" },
      { image: "/img/hypersaline-4.jpeg" },
    ],
  },
  {
    id: "stamp-book",
    title: "amma & mamman's stamp book",
    info: "2025",
    description:
      "a collection of stamps from my family's childhood stamp collection from the 1960s-1990s scanned and researched from the original album. features stamps from india, mauritius, and many other former commonwealth countries, depicting an interesting glimpse into post-colonial national identities.",
    images: [
      { image: "/img/stamp-book-1.jpeg" },
      { image: "/img/stamp-book-2.jpeg" },
      { image: "/img/stamp-book-3.jpeg" },
      { image: "/img/stamp-book-4.jpeg" },
      { image: "/img/stamp-book-5.jpeg" },
      { image: "/img/stamp-book-6.jpeg" },
    ],
  },
  {
    id: "blue-ink",
    title: "a sketchbook for blue ink",
    info: "2025",
    description:
      "a collection of blue ink sketches of landscapes from vidya's sketchbook between 2022-2025.",
    images: [
      { image: "/img/blue-ink-1.jpeg" },
      { image: "/img/blue-ink-2.jpeg" },
      { image: "/img/blue-ink-3.jpeg" },
      { image: "/img/blue-ink-4.jpeg" },
      { image: "/img/blue-ink-5.jpeg" },
      { image: "/img/blue-ink-6.jpeg" },
    ],
  },
  {
    id: "href-place",
    title: "href.place postcard book",
    info: "2026",
    description: "a collection of 101 hand-drawn postcards from the independent web!",
    images: [
      { image: "/releases/016.png" },
      { image: "/img/href-place-postcard-1.jpeg" },
      { image: "/img/href-place-postcard-2.jpeg" },
      { image: "/img/href-place-postcard-3.jpeg" },
      { image: "/img/href-place-9.jpeg" },
      { image: "/img/href-place-8.jpeg" },
      { image: "/img/href-place-7.jpeg" },
    ],
  },
  {
    id: "birds-we-saw-in-woodland-park",
    title: "birds we saw in woodland park",
    info: "2025",
    description: "a comic about birds observed flitting around a city park in houston.",
    images: [
      { image: "/releases/015.png" },
      { image: "/img/birds-we-saw-1.jpeg" },
      { image: "/img/birds-we-saw-2.jpeg" },
    ],
  },
  {
    id: "wildflowers-of-texas",
    title: "wildflowers of texas",
    info: "2022",
    description:
      "a compilation of watercolor illustrations of texan wildflowers alongside reference information from the ladybird johnson center",
    images: [
      { image: "/releases/003.png" },
      { image: "/img/wildflowers-1.jpg" },
      { image: "/img/wildflowers-2.jpeg" },
      { image: "/img/wildflowers-3.jpeg" },
      { image: "/img/wildflowers-4.jpeg" },
    ],
  },
  {
    id: "pixel-memories",
    title: "pixel memories",
    info: "2022",
    description:
      "snippets of places and things from moments in my life, rendered in pixels",
    images: [
      { image: "/releases/001.png" },
      { image: "/img/pixel-memories-2.jpeg" },
      { image: "/img/pixel-memories-1.jpeg" },
    ],
  },
  {
    id: "my-crystals",
    title: "my crystals",
    info: "2022",
    description:
      "a small comic about a dragonoose creature who loves collecting crystals",
    images: [
      { image: "/releases/002.png" },
      { image: "/img/my-crystals-1.jpeg" },
      { image: "/img/my-crystals-2.jpeg" },
    ],
  },
  {
    id: "mini-zines",
    title: "mini zines",
    info: "2022-2025",
    description:
      "i have also published a few mini zines: mushroom meshes, kudzu, eyebrow chaos + more",
    images: [
      { image: "/releases/005.png" },
      { image: "/releases/007.png" },
      { image: "/releases/008.png" },
      { image: "/releases/006.png" },
      { image: "/img/mini-zines-1.jpeg" },
      { image: "/img/mini-zines-2.jpeg" },
      { image: "/img/mini-zines-3.jpeg" },
      { image: "/img/mini-zines-4.jpeg" },
      { image: "/img/mini-zines-5.jpeg" },
      { image: "/img/mini-zines-6.jpeg" },
      { image: "/img/mini-zines-7.jpeg" },
      { image: "/img/mini-zines-8.jpeg" },
      { image: "/img/mini-zines-9.jpeg" },
    ],
  },
];

const useStyles = createStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#fff",
    color: "#000",

    [theme.fn.smallerThan(MOBILE_BREAKPOINT)]: {
      display: "flex",
      flexDirection: "column",
    },

    [theme.fn.largerThan(MOBILE_BREAKPOINT)]: {
      display: "flex",
    },
  },

  sidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    width: SIDEBAR_WIDTH,
    boxSizing: "border-box",
    padding: rem(32),
    paddingTop: CONTENT_TOP,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    zIndex: 10,
    overflowY: "auto",

    [theme.fn.smallerThan(MOBILE_BREAKPOINT)]: {
      display: "none",
    },
  },

  mobileHeader: {
    display: "none",

    [theme.fn.smallerThan(MOBILE_BREAKPOINT)]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "sticky",
      top: 0,
      zIndex: 10,
      backgroundColor: "#fff",
      padding: rem(16),
      paddingLeft: MOBILE_GUTTER,
      paddingRight: MOBILE_GUTTER,
      gap: rem(16),
    },
  },

  mobileMenu: {
    padding: `${rem(8)} ${MOBILE_GUTTER} ${rem(20)}`,
    backgroundColor: "#fff",
  },

  mobileNav: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: rem(20),
  },

  title: {
    fontSize: rem(28),
    lineHeight: 1.25,
    fontFamily: "Nanum Myeongjo, serif",
    color: "#000",
    letterSpacing: rem(0.5),
    wordBreak: "break-word",

    [theme.fn.smallerThan(MOBILE_BREAKPOINT)]: {
      fontSize: rem(18),
      lineHeight: 1.2,
      flex: 1,
    },
  },

  nav: {
    marginTop: rem(32),
    display: "flex",
    flexDirection: "column",
    gap: rem(10),
  },

  navLink: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(13),
    color: "#000",
    textDecoration: "none",
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    textAlign: "left",
    textUnderlineOffset: rem(4),

    "&:hover": {
      textDecoration: "underline",
    },
  },

  navLinkActive: {
    textDecoration: "underline",
  },

  menuButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: rem(40),
    height: rem(40),
    padding: 0,
    border: "none",
    background: "none",
    cursor: "pointer",
    color: "#000",
  },

  main: {
    marginLeft: SIDEBAR_WIDTH,
    flex: 1,
    padding: rem(24),
    paddingTop: CONTENT_TOP,
    minWidth: 0,
    boxSizing: "border-box",

    [theme.fn.smallerThan(MOBILE_BREAKPOINT)]: {
      marginLeft: 0,
      paddingTop: rem(12),
      paddingBottom: rem(24),
      paddingLeft: MOBILE_GUTTER,
      paddingRight: MOBILE_GUTTER,
    },
  },

  workIntro: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(13),
    lineHeight: 1.75,
    color: "#000",
    marginBottom: rem(40),
  },

  sectionHeading: {
    fontFamily: "Nanum Myeongjo, serif",
    fontSize: rem(20),
    color: "#000",
    marginTop: rem(8),
    marginBottom: rem(28),
  },

  entry: {
    marginBottom: rem(56),
  },

  entryTitle: {
    fontFamily: "Nanum Myeongjo, serif",
    fontSize: rem(18),
    color: "#000",
    marginBottom: rem(4),
  },

  entryDate: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(12),
    color: "#000",
    textTransform: "uppercase",
    letterSpacing: rem(0.4),
    marginBottom: rem(8),
  },

  entryBlurb: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(13),
    lineHeight: 1.75,
    color: "#000",
    marginBottom: rem(16),
    maxWidth: rem(640),
  },

  tableSection: {
    marginTop: rem(48),
    marginBottom: rem(24),
  },
}));

function MenuIcon() {
  return (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" aria-hidden="true">
      <path d="M0 1H22" stroke="currentColor" strokeWidth="1.5" />
      <path d="M0 8H22" stroke="currentColor" strokeWidth="1.5" />
      <path d="M0 15H22" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

interface NavLinksProps {
  view: PageView;
  onViewChange: (view: PageView) => void;
  className?: string;
  linkClassName: string;
  activeLinkClassName: string;
}

function NavLinks({
  view,
  onViewChange,
  className,
  linkClassName,
  activeLinkClassName,
}: NavLinksProps) {
  const linkClass = (isActive: boolean) =>
    isActive ? `${linkClassName} ${activeLinkClassName}` : linkClassName;

  return (
    <nav className={className}>
      <button
        type="button"
        className={linkClass(view === "work")}
        onClick={() => onViewChange("work")}
      >
        work
      </button>
      <button
        type="button"
        className={linkClass(view === "about")}
        onClick={() => onViewChange("about")}
      >
        about
      </button>
      <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className={linkClassName}>
        instagram
      </a>
    </nav>
  );
}

function ProjectEntry({ project }: { project: Project }) {
  const { classes } = useStyles();

  return (
    <article className={classes.entry}>
      <Text className={classes.entryTitle}>{project.title}</Text>
      <Text className={classes.entryDate}>{project.info}</Text>
      <Text className={classes.entryBlurb}>{project.description}</Text>
      {project.images.length > 0 && (
        <CardsCarousel
          images={project.images.map((img) => ({ image: img.image, caption: project.title }))}
        />
      )}
    </article>
  );
}

export function DallasZineFest2026Page() {
  const { classes } = useStyles();
  const [view, setView] = React.useState<PageView>("work");
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    document.title = "Vidya Giri / ixorem — Dallas Zine Fest 2026";
  }, []);

  const handleViewChange = (nextView: PageView) => {
    setView(nextView);
    setMenuOpen(false);
  };

  return (
    <div className={classes.root}>
      <aside className={classes.sidebar}>
        <Text className={classes.title}>Vidya Giri / ixorem</Text>
        <NavLinks
          view={view}
          onViewChange={handleViewChange}
          className={classes.nav}
          linkClassName={classes.navLink}
          activeLinkClassName={classes.navLinkActive}
        />
      </aside>

      <header className={classes.mobileHeader}>
        <Text className={classes.title}>Vidya Giri / ixorem</Text>
        <button
          type="button"
          className={classes.menuButton}
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <MenuIcon />
        </button>
      </header>

      {menuOpen && (
        <div className={classes.mobileMenu}>
          <NavLinks
            view={view}
            onViewChange={handleViewChange}
            className={classes.mobileNav}
            linkClassName={classes.navLink}
            activeLinkClassName={classes.navLinkActive}
          />
        </div>
      )}

      <main className={classes.main}>
        {view === "about" ? (
          <AboutContent />
        ) : (
          <div>
            <Text className={classes.workIntro}>
              hi! here is some of my work! zines! short books! bits of paper!
            </Text>

            <div className={classes.tableSection}>
              <Text className={classes.sectionHeading}>sample table pictures</Text>
              <CardsCarousel
                imageHeight={320}
                images={[
                  { image: "/tables/santa-rosa-zine-fest.jpg", caption: "santa rosa zine fest" },
                  { image: "/tables/babf.png", caption: "bay area book fest" },
                  { image: "/tables/dabf-1.JPG", caption: "previous table setup" },
                ]}
              />
            </div>

            {printed.map((project) => (
              <ProjectEntry key={project.id} project={project} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
